import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import React from 'react'
import { TextField, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { DialogActions, DialogContent, Modal } from '../../../../components/Modal/Modal'
import { FormRow } from '../../../../components/FormRow/FormRow'
import { ErrorExplanation } from '../../../../components/ErrorExplanation/ErrorExplanation'
import { SubmitButton } from '../../../../components/SubmitButton/SubmitButton'
import { useShow } from '../../../../hooks/useShow'
import { gamesQueryKey } from '../../../../api/queries'
import { ICreateGame, IGame } from '../../../../api/types/game'
import { useApiErrors } from '../../../../hooks/useApiErrors'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationCreateGame } from '../../../../api/mutations'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(0.5),
    },
  })
)

export const CreateGame = () => {
  const { show, doHide, doShow } = useShow()
  const { apiErrors, setApiErrors, setApiErrorsFromAxios } = useApiErrors()
  const { register, handleSubmit, errors } = useForm<ICreateGame>()
  const queryClient = useQueryClient()
  const classes = useStyles()

  const { mutate: createGameMutation, isLoading: isMutating } = useMutation(
    (newGame: ICreateGame) => mutationCreateGame(newGame),
    {
      onError: (err: any) => {
        setApiErrorsFromAxios(err, 'Nie udało się stworzyć gry')
      },
      onSuccess: async () => {
        setApiErrors([])
        queryClient.invalidateQueries(gamesQueryKey()).then(doHide)
      },
    }
  )

  const onSubmit = (data: IGame) => createGameMutation(data)

  return (
    <>
      <Button
        variant="outlined"
        className={classes.button}
        color="primary"
        size="small"
        startIcon={<AddIcon />}
        onClick={doShow}
      >
        Create game
      </Button>

      <Modal open={show} onClose={doHide} title="Stwórz nową grę">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent dividers>
            <FormRow>
              <ErrorExplanation errors={apiErrors} />
            </FormRow>
            <FormRow>
              <TextField
                name="name"
                label="Name"
                fullWidth={true}
                variant="outlined"
                inputProps={{
                  ref: register({
                    required: 'Wymagane',
                    minLength: { value: 3, message: 'Minimum 3 znaki' },
                    maxLength: { value: 64, message: 'Maksimum 64 znaki' },
                  }),
                }}
                error={!!errors.name}
                helperText={errors.name && errors.name.message}
              />
            </FormRow>
          </DialogContent>
          <DialogActions>
            <SubmitButton disabled={isMutating}>Create</SubmitButton>
          </DialogActions>
        </form>
      </Modal>
    </>
  )
}
